import { render, staticRenderFns } from "./AttributeValueEditDialog.vue?vue&type=template&id=24fd9958&scoped=true"
import script from "./AttributeValueEditDialog.vue?vue&type=script&lang=js"
export * from "./AttributeValueEditDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24fd9958",
  null
  
)

export default component.exports